<template>
	<div id="app">
		<router-view></router-view>
	</div>
</template>

<script>
import { accountSetup } from '@/services/login.service';
import axios from 'axios';
import SocketioService from '@/services/socketio.service.js';
import Vue from 'vue';

export default {
	name: 'App',
	components: {},
	created() {
		this.$store.dispatch('initDarkMode');
		if (!this.$route.meta.nocheck) {
			if (localStorage.getItem('token')) {
				this.$store.state.token = localStorage.getItem('token');
			}

			axios.defaults.headers.common['x-access-token'] = this.$store.state.token;
			axios.defaults.headers.common['x-access-token'] = this.$store.state.token;

			this.$store.state.account_setup = true;
			this.$store.commit('set_loading_page', 'setup');

			this.$store.socket = SocketioService;
			this.$store.socket.setupSocketConnection(
				Vue.prototype.$apiBase.replace('/api', '')
			);
			//this.$store.socket.sendRSelectRemark
			accountSetup()
				.then((d) => {
					//console.log("d", d)
					if (d.data.name) {
						this.$store.state.name = d.data.name;
					}
					if (d.data.login_system) {
						this.$store.state.login_system = d.data.login_system;
					}
					if (d.data.userId) {
						this.$store.state.userId = d.data.userId;
					}

					if (d.data.userUid) {
						this.$store.state.user_uid = d.data.userUid;
					}

					if (d.data.company) {
						this.$store.state.company = d.data.company;
					}

					let newTestProject = JSON.parse(
						JSON.stringify(this.$store.state.testProject)
					);

					if (d.data.userId && !d.data.old_testproject) {
						newTestProject.projectId = '00000000' + d.data.userId;
						newTestProject._id = '00000000' + d.data.userId;
						newTestProject.uid = '00000000' + d.data.userId;
						newTestProject.projectnumber = '00000000' + d.data.userId;
					}

					if (d.data.projects) {
						d.data.projects.push(newTestProject);
						this.$store.commit('set_projects', d.data.projects);
					} else {
						this.$store.commit('set_projects', [newTestProject]);
					}

					if (d.data.account_role) {
						this.$store.state.account_role = d.data.account_role;
					}

					if (d.data.dm_rolle !== undefined) {
						this.$store.commit('set_dm_rolle', d.data.dm_rolle);
					}
					if (d.data.dm_berechtigungen) {
						this.$store.commit('set_dm_berechtigungen', d.data.dm_berechtigungen);
					}

					this.$store.commit('set_account_setup_done', true);
					this.$store.commit('set_loading_page', null);
				})
				.catch((e) => {
					this.$store.commit('set_account_setup_done', true);
					this.$store.dispatch('api_error', e);
				});
		}
	},
};
</script>

<style>
@media only screen and (max-width: 760px) {
	.hide-mobile {
		display: none;
	}
}

/* Dark Mode Overrides - component-specific (general overrides in custom-theme.css) */

.dark-mode .imgupload-conteiner {
	background-color: #1e2a3a;
	border-color: #3c4d62;
}

/* ReportV3 Dark Mode */
.dark-mode .card.card-preview {
	background-color: #1a2332;
	border-color: #3c4d62;
}

.dark-mode .chapter-column {
	background-color: #141c26 !important;
}

.dark-mode .content-column {
	background-color: #1a2332;
}

.dark-mode .lang-toggle {
	background: #1e2a3a !important;
	border-color: #3c4d62 !important;
	color: #b6c6e3 !important;
}

.dark-mode .nav-sidebar-toggle-btn {
	background: #1e2a3a !important;
	border-color: #3c4d62 !important;
	color: #b6c6e3 !important;
}

.dark-mode .nav-sidebar-toggle-btn:hover {
	background: #253345 !important;
}

.dark-mode .shortcut-modal {
	background: #1a2332 !important;
	border: 1px solid #3c4d62 !important;
}

.dark-mode .shortcut-header {
	border-color: #3c4d62 !important;
	color: #b6c6e3;
}

.dark-mode .shortcut-header h5 {
	color: #fff;
}

.dark-mode .shortcut-header .btn {
	color: #b6c6e3;
}

.dark-mode .shortcut-body {
	background: #1a2332 !important;
	color: #b6c6e3;
}

.dark-mode .shortcut-body kbd {
	background: #141c26;
	color: #b6c6e3;
	border-color: #3c4d62;
}

.dark-mode .status-filter-bar {
	border-color: #3c4d62;
}

.dark-mode .status-filter-btn {
	background: #1e2a3a;
	border-color: #3c4d62;
	color: #b6c6e3;
}

.dark-mode .table {
	color: #b6c6e3;
}

.dark-mode .table thead th {
	border-color: #3c4d62;
	color: #b6c6e3;
}

.dark-mode .table td,
.dark-mode .table th {
	border-top-color: #3c4d62;
	border-bottom-color: #3c4d62;
}

.dark-mode .breadcrumb {
	background-color: transparent;
}

.dark-mode .breadcrumb-item a {
	color: #E8751A;
}

.dark-mode .form-control {
	background-color: #1e2a3a;
	border-color: #3c4d62;
	color: #b6c6e3;
}

.dark-mode .form-control::placeholder {
	color: #8094ae;
}

.dark-mode .breadcrumb-container {
	background-color: #141c26 !important;
	border-bottom: 1px solid #3c4d62 !important;
}

.dark-mode .breadcrumb-container .breadcrumb-item.active {
	color: #fff !important;
}

.dark-mode .breadcrumb-container .breadcrumb-item + .breadcrumb-item::before {
	color: #8094ae;
}

.dark-mode .preview-block {
	background-color: #1a2332 !important;
}

.dark-mode .container-col1,
.dark-mode .content-col1 {
	background-color: #1a2332 !important;
}

.dark-mode .insection_selected {
	background-color: #2d3f54 !important;
}

.dark-mode .findings-table-container {
	background-color: #1a2332 !important;
	border-color: #3c4d62 !important;
}

.dark-mode .findings-table .sticky-header {
	background: #1a2332 !important;
}

.dark-mode .findings-table .sticky-header th {
	color: #b6c6e3;
	border-color: #3c4d62 !important;
}

/* Modal Dark Mode */
.dark-mode .modal-content {
	background-color: #1a2332 !important;
	border-color: #3c4d62 !important;
}

.dark-mode .modal-header {
	border-color: #3c4d62 !important;
}

.dark-mode .modal-header .modal-title {
	color: #b6c6e3;
}

.dark-mode .modal-header .close {
	color: #b6c6e3;
}

.dark-mode .modal-body {
	color: #b6c6e3;
}

.dark-mode .modal-footer {
	border-color: #3c4d62 !important;
}

.dark-mode .modal-footer.bg-light {
	background-color: #141c26 !important;
}

.dark-mode .finding-preview {
	background: #141c26 !important;
	border-color: #3c4d62 !important;
}

.dark-mode .finding-text {
	color: #b6c6e3 !important;
}

.dark-mode .comments-section {
	border-color: #3c4d62 !important;
}

.dark-mode .comment-item {
	border-color: #3c4d62 !important;
}

.dark-mode .comment-author {
	color: #fff !important;
}

.dark-mode .comment-text {
	color: #b6c6e3 !important;
}

.dark-mode .add-comment-section {
	border-color: #3c4d62 !important;
}

.dark-mode textarea.form-control {
	background-color: #1e2a3a !important;
	border-color: #3c4d62 !important;
	color: #b6c6e3 !important;
}

.dark-mode .text-muted {
	color: #8094ae !important;
}

.dark-mode .icon-bg {
	background-color: #141c26 !important;
}

/* Login Page Dark Mode */
.dark-mode .card.card-bordered {
	background-color: #1a2332 !important;
	border-color: #3c4d62 !important;
}

.dark-mode .nk-block-title {
	color: #fff;
}

.dark-mode .nk-block-des p {
	color: #b6c6e3;
}

.dark-mode .form-label {
	color: #b6c6e3;
}

.dark-mode select.form-control {
	background-color: #1e2a3a !important;
	border-color: #3c4d62 !important;
	color: #b6c6e3 !important;
}

/* Loading Overlay Dark Mode */
.dark-mode .vld-background {
	background: #0d1520 !important;
	opacity: 0.85 !important;
}
</style>
